
import {get} from "vuex-pathify";
export default {

    computed: {
        meta: get('form/resource_form@comment'),
        slider_tablet_archos(){
            return _.get(this.meta,'slider_tablet_archos')
        },
        slider_chromecast(){
            return _.get(this.meta,'slider_chromecast')
        },
        slider_senseo(){
            return _.get(this.meta,'slider_senseo')
        },
        slider_soundbar(){
            return _.get(this.meta,'slider_soundbar')
        },
        slider_robot(){
            return _.get(this.meta,'slider_robot')
        },

    },
}
